const prescription = (request, api_config) => {
  const prefix = "Prescription";

  const GetPrescriptionManageFilters = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetPrescriptionManageFilters`,
      method: "get",
      params: data,
    });
    return result;
  };

  const GetPrescriptionManageListByPage = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetPrescriptionManageListByPage`,
      method: "post",
      data: data,
    });
    return result;
  };

  const CreatePrescription = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/CreatePrescription`,
      method: "post",
      data: data,
    });
    return result;
  };

  const GetPrescriptionById = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetPrescriptionById`,
      method: "get",
      params: data,
    });
    return result;
  };

  const GetPrescriptionPharmacists = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetPrescriptionPharmacists`,
      method: "get",
      params: data,
    });
    return result;
  };

  const SubmitPrescription = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/SubmitPrescription`,
      method: "post",
      data: data,
    });
    return result;
  };

  const RejectPrescription = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/RejectPrescription`,
      method: "post",
      data: data,
    });
    return result;
  };

  const ResetPrescription = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/ResetPrescription`,
      method: "post",
      data: data,
    });
    return result;
  };

  const GetPrescriptionProgress = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetPrescriptionProgress`,
      method: "get",
      params: data,
    });
    return result;
  };

  const GetPrescriptionChainStores = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetPrescriptionChainStores`,
      method: "get",
      params: data,
    });
    return result;
  };

  const GetPreAuditPrescriptions = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetPreAuditPrescriptions`,
      method: "get",
      params: data,
    });
    return result;
  };

  const AuditPrescription = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/AuditPrescription`,
      method: "post",
      data: data,
    });
    return result;
  };

  const GetPrescriptionPlatforms = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetPrescriptionPlatforms`,
      method: "get",
      params: data,
    });
    return result;
  };

  const SetPrescriptionPlatform = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/SetPrescriptionPlatform`,
      method: "post",
      data: data,
    });
    return result;
  };

  const AddPrescriptionBarcodes = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/AddPrescriptionBarcodes`,
      method: "post",
      data: data,
    });
    return result;
  };

  const VerifyBarcode = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/VerifyBarcode`,
      method: "get",
      params: data,
    });
    return result;
  };

  const GetPrescriptionBarcodes = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetPrescriptionBarcodes`,
      method: "get",
      params: data,
    });
    return result;
  };

  const SetMedicalPaid = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/SetMedicalPaid`,
      method: "post",
      data: data,
    });
    return result;
  };

  return {
    GetPrescriptionManageFilters,
    GetPrescriptionManageListByPage,
    CreatePrescription,
    GetPrescriptionById,
    GetPrescriptionPharmacists,
    SubmitPrescription,
    RejectPrescription,
    ResetPrescription,
    GetPrescriptionProgress,
    GetPrescriptionChainStores,
    GetPreAuditPrescriptions,
    AuditPrescription,
    GetPrescriptionPlatforms,
    SetPrescriptionPlatform,
    AddPrescriptionBarcodes,
    VerifyBarcode,
    GetPrescriptionBarcodes,
    SetMedicalPaid,
  };
};

export default prescription;
